







import { Component, Vue } from 'vue-property-decorator';
import AdminIframe from '@/components/iframe/AdminIframe.vue';
import PageTitle from '@/components/common/PageTitle.vue';

@Component({
  components: { AdminIframe, PageTitle },
})
export default class RecurringPaymentsProductRegisterIframe extends Vue {
  private title = '';
  private remoteSrc = '';

  private setRemoteSrc() {
    const { query, path } = this.$route;

    this.title = this.$t('RECURRINGPAYMENTS_PRODUCT_RECURRING_PAYMENTS_PRODUCT_REGISTER') as string;
    let action = 'add';
    if (path.includes('edit')) {
      this.title = this.$t('RECURRINGPAYMENTS_PRODUCT_RECURRING_PAYMENTS_PRODUCT_EDIT') as string;
      action = 'edit';
    }

    const queryObject = { ...query, serviceType: 'PREMIUM' };
    const queryString = new URLSearchParams(queryObject).toString();
    this.remoteSrc = process.env.VUE_APP_ADMIN_REMOTE_URL + `/product/subscribable/${action}${queryString ? `?${queryString}` : ''}`;
  }

  created() {
    this.setRemoteSrc();
  }
}
